module.exports = __webpack_public_path__ + "img/GP1_Austria.0deaeda0.png";